// extracted by mini-css-extract-plugin
export default {"label":"Range_label__GSis2","input":"Range_input__Ps5FX","output":"Range_output__Y7CPP"};